// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../static/images/aimodel-banner.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../static/images/a1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../static/images/a2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../static/images/a3.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../static/images/aiback-a.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../static/images/hetong-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aimodelBanner {
  height: 430px;
  min-width: 1200px;
  width: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat top center;
}
.aimodel {
  padding-bottom: 50px;
}
.aimodel .ant-anchor {
  display: flex;
  width: 1200px;
  margin: 0px auto;
}
.aimodel .ant-anchor-link {
  flex: 1;
  max-width: 16%;
  border: 1px solid #ddd;
  border-left: 0px;
  height: 200px;
  background: #fff;
  text-align: center;
  cursor: pointer;
  padding-inline: 0px !important;
}
.aimodel .ant-anchor-link a {
  text-align: center;
  white-space: pre-wrap !important;
  padding: 0px 15px;
}
.aimodel .ant-anchor-link:nth-of-type(1) {
  border-left: 1px solid #ddd;
}
.aimodel .ant-anchor-wrapper:before {
  border-bottom: 0px !important;
}
.aimodel .ant-anchor-link a::before {
  content: '';
  display: block;
  height: 140px;
}
.aimodel .text {
  line-height: 30px;
  display: block;
}
.aimodel .ant-anchor-link:nth-of-type(1) a::before,
.aimodel .ant-anchor-link:nth-of-type(4) a::before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center 40px;
}
.aimodel .ant-anchor-link:nth-of-type(2) a::before,
.aimodel .ant-anchor-link:nth-of-type(5) a::before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center 40px;
}
.aimodel .ant-anchor-link:nth-of-type(3) a::before,
.aimodel .ant-anchor-link:nth-of-type(6) a::before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat center 40px;
}
.aimodel .ant-affix .ant-anchor-link {
  flex: 1;
  border: 1px solid #ddd;
  border-left: 0px;
  height: 50px;
  line-height: 40px;
  background: #fff;
  text-align: center;
  cursor: pointer;
  padding-inline: 0px !important;
}
.aimodel .ant-affix .ant-anchor-link a::before {
  content: '';
  display: none;
}
.aimodel .ant-affix .ant-anchor-link:nth-of-type(1) {
  border-left: 1px solid #ddd;
}
.zhijian {
  width: 100%;
  background: #f2f5fa;
  padding-bottom: 50px;
  min-width: 1200px;
}
.zhijian .content {
  width: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat top center;
  height: 399px;
}
.zhijian .content-right {
  width: 1200px;
  margin: 0px auto;
  padding-top: 60px;
}
.zhijian .content ul {
  width: 74%;
  margin-left: 26%;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 10px;
  height: 260px;
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
}
.zhijian .content li {
  width: 45%;
  font-size: 14px;
  padding: 10px;
  box-sizing: border-box;
}
.zhijian .content li h3 {
  margin: 0px;
  line-height: 40px;
}
.zhijian .content li:nth-of-type(2n+1) {
  width: 55%;
}
.toubiao {
  padding-bottom: 50px;
}
.toubiao ul {
  width: 1200px;
  margin: 0px auto;
  display: flex;
  justify-content: space-between;
}
.toubiao li {
  width: 288px;
  background: #fff;
  box-shadow: 0px 0px 5px 5px rgba(0, 0, 0, 0.05);
}
.toubiao li h3 {
  margin: 0px;
  padding: 0px 15px;
  line-height: 50px;
  font-size: 16px;
}
.toubiao li p {
  font-size: 14px;
  padding: 0px 15px;
  line-height: 30px;
  margin: 0px;
  padding-bottom: 20px;
  color: #555;
}
.hetong {
  width: 100%;
  background: #f2f5fa;
  padding-bottom: 50px;
  min-width: 1200px;
}
.hetong ul {
  width: 1200px;
  margin: 0px auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.hetong .list {
  margin: 0px 15px 15px 15px;
}
.hetong li {
  width: calc(33.3% - 10px);
  box-sizing: border-box;
  margin-bottom: 15px;
  background: #fff;
  box-shadow: 0px 0px 5px 5px rgba(0, 0, 0, 0.05);
}
.hetong p {
  font-size: 14px;
  line-height: 34px;
  background: #fbfbfe url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat bottom right;
  margin: 10px;
  padding: 15px 10px;
  height: 120px;
  color: #555;
}
.hetong-con h3 {
  font-size: 16px;
  padding-left: 20px;
}
.suppleBox ul {
  width: 1200px;
  margin: 0px auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.suppleBox li {
  width: calc(50% - 10px);
  box-shadow: 0px 0px 5px 5px rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
  margin-bottom: 20px;
  border-radius: 5px;
  padding-bottom: 20px;
}
.suppleBox li h3 {
  font-size: 16px;
  padding-left: 20px;
  margin: 0px;
  line-height: 50px;
}
.suppleBox li:nth-of-type(2n+1) {
  margin-right: 20px;
}
.suppleBox p {
  font-size: 14px;
  line-height: 34px;
  margin: 0px;
  padding: 0px 20px;
  color: #555;
}
.jiage {
  width: 100%;
  padding-bottom: 50px;
}
.jiage ul {
  width: 1200px;
  margin: 0px auto;
  display: flex;
  justify-content: space-between;
}
.jiage li {
  flex: 1;
  box-shadow: 0px 0px 5px 5px rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
  background: #fff;
  padding-bottom: 20px;
  border-radius: 5px;
  padding: 20px;
}
.jiage .list {
  margin: 0px 20px 0px 20px;
}
.jiage p {
  font-size: 14px;
  line-height: 34px;
  margin: 0px;
  color: #555;
}
.shichang {
  width: 100%;
  padding-bottom: 50px;
  background: #f2f5fa;
  min-width: 1200px;
}
.shichang ul {
  width: 1200px;
  margin: 0px auto;
  display: flex;
  justify-content: space-between;
}
.shichang li {
  flex: 1;
  box-sizing: border-box;
  background: #fff;
  padding-bottom: 20px;
  border-radius: 5px;
}
.shichang .titleicon {
  display: flex;
}
.shichang .titleicon h3 {
  padding-left: 20px;
}
.shichang .list {
  margin: 0px 40px 0px 40px;
}
.shichang p {
  font-size: 14px;
  line-height: 34px;
  margin: 0px;
  color: #555;
}
`, "",{"version":3,"sources":["webpack://./src/pages/AiModel/index.less"],"names":[],"mappings":"AAAA;EACG,aAAA;EAAc,iBAAA;EAAkB,WAAA;EAAY,wEAAA;AAI/C;AAFA;EAAS,oBAAA;AAKT;AALA;EACe,aAAA;EAAe,aAAA;EAAc,gBAAA;AAS5C;AAVA;EAGM,OAAA;EAAQ,cAAA;EAAe,sBAAA;EAAuB,gBAAA;EAAiB,aAAA;EAAc,gBAAA;EAC7E,kBAAA;EAAoB,eAAA;EAAiB,8BAAA;AAiB3C;AArBA;EAMsB,kBAAA;EAAwB,gCAAA;EAAkC,iBAAA;AAoBhF;AA1BA;EAOmC,2BAAA;AAsBnC;AA7BA;EAQ8B,6BAAA;AAwB9B;AAhCA;EAS8B,WAAA;EAAY,cAAA;EAAgB,aAAA;AA4B1D;AArCA;EAUS,iBAAA;EAAkB,cAAA;AA+B3B;AAzCA;;EAWwF,yEAAA;AAkCxF;AA7CA;;EAYwF,yEAAA;AAqCxF;AAjDA;;EAawF,yEAAA;AAwCxF;AArDA;EAgBS,OAAA;EAAQ,sBAAA;EAAuB,gBAAA;EAAiB,YAAA;EAAa,iBAAA;EAAkB,gBAAA;EAC/E,kBAAA;EAAoB,eAAA;EAAiB,8BAAA;AA+C9C;AAhEA;EAmBiC,WAAA;EAAY,aAAA;AAiD7C;AApEA;EAoBsC,2BAAA;AAmDtC;AAhDA;EAAS,WAAA;EAAY,mBAAA;EAAoB,oBAAA;EAAsB,iBAAA;AAsD/D;AAtDA;EACY,WAAA;EAAY,wEAAA;EAAwE,aAAA;AA0DhG;AAzDM;EAAQ,aAAA;EAAc,gBAAA;EAAiB,iBAAA;AA8D7C;AAhEA;EAGS,UAAA;EAAW,gBAAA;EAAiB,oCAAA;EAAkC,mBAAA;EAAoB,aAAA;EAAc,aAAA;EAAe,eAAA;EAAiB,aAAA;AAuEzI;AA1EA;EAIS,UAAA;EAAW,eAAA;EAAgB,aAAA;EAAc,sBAAA;AA4ElD;AAhFA;EAKY,WAAA;EAAa,iBAAA;AA+EzB;AApFA;EAO2B,UAAA;AAgF3B;AA7EA;EAAS,oBAAA;AAgFT;AAhFA;EACM,aAAA;EAAc,gBAAA;EAAiB,aAAA;EAAe,8BAAA;AAqFpD;AAtFA;EAEM,YAAA;EAAa,gBAAA;EAAiB,+CAAA;AAyFpC;AA3FA;EAGS,WAAA;EAAY,iBAAA;EAAkB,iBAAA;EAAmB,eAAA;AA8F1D;AAjGA;EAIQ,eAAA;EAAiB,iBAAA;EAAkB,iBAAA;EAAmB,WAAA;EAAY,oBAAA;EAAqB,WAAA;AAqG/F;AAlGA;EAAQ,WAAA;EAAY,mBAAA;EAAoB,oBAAA;EAAsB,iBAAA;AAwG9D;AAxGA;EACM,aAAA;EAAc,gBAAA;EAAiB,aAAA;EAAe,8BAAA;EAAgC,eAAA;AA8GpF;AA/GA;EAES,0BAAA;AAgHT;AAlHA;EAGM,yBAAA;EAA0B,sBAAA;EAAwB,mBAAA;EAAoB,gBAAA;EAAiB,+CAAA;AAsH7F;AAzHA;EAKM,eAAA;EAAgB,iBAAA;EAAkB,kFAAA;EAAkF,YAAA;EACpH,kBAAA;EAAmB,aAAA;EAAc,WAAA;AA4HvC;AA1HG;EACM,eAAA;EAAiB,kBAAA;AA6H1B;AAxHA;EACM,aAAA;EAAc,gBAAA;EAAiB,aAAA;EAAe,8BAAA;EAAgC,eAAA;AA8HpF;AA/HA;EAGM,uBAAA;EAAwB,+CAAA;EAA8C,sBAAA;EACtE,mBAAA;EAAoB,kBAAA;EAAmB,oBAAA;AAmI7C;AAvIA;EAKS,eAAA;EAAiB,kBAAA;EAAmB,WAAA;EAAa,iBAAA;AAwI1D;AA7IA;EAOwB,kBAAA;AAyIxB;AAhJA;EASM,eAAA;EAAgB,iBAAA;EAAkB,WAAA;EAClC,iBAAA;EAAkB,WAAA;AA6IxB;AAzIA;EAAO,WAAA;EAAa,oBAAA;AA6IpB;AA7IA;EACM,aAAA;EAAc,gBAAA;EAAiB,aAAA;EAAe,8BAAA;AAkJpD;AAnJA;EAGM,OAAA;EAAQ,+CAAA;EAA8C,sBAAA;EAAwB,gBAAA;EAC3D,oBAAA;EAAqB,kBAAA;EAAmB,aAAA;AAwJjE;AA5JA;EAMS,yBAAA;AAyJT;AA/JA;EAQM,eAAA;EAAgB,iBAAA;EAAkB,WAAA;EAAY,WAAA;AA6JpD;AA1JA;EAAU,WAAA;EAAY,oBAAA;EAAsB,mBAAA;EAAoB,iBAAA;AAgKhE;AAhKA;EACM,aAAA;EAAc,gBAAA;EAAiB,aAAA;EAAe,8BAAA;AAqKpD;AAtKA;EAGM,OAAA;EAAQ,sBAAA;EAAwB,gBAAA;EACb,oBAAA;EAAqB,kBAAA;AAyK9C;AA7KA;EAMc,aAAA;AA0Kd;AAhLA;EAOS,kBAAA;AA4KT;AAnLA;EASS,yBAAA;AA6KT;AAtLA;EAWM,eAAA;EAAgB,iBAAA;EAAkB,WAAA;EAAY,WAAA;AAiLpD","sourcesContent":[".aimodelBanner{\n   height:430px; min-width:1200px; width:100%; background:url(../../static/images/aimodel-banner.jpg) no-repeat top center;\n}\n.aimodel{padding-bottom:50px;\n   .ant-anchor{display: flex; width:1200px; margin:0px auto;}\n   .ant-anchor-link{\n      flex:1; max-width:16%; border:1px solid #ddd; border-left:0px; height:200px; background:#fff; \n      text-align: center; cursor: pointer; padding-inline:0px !important;\n   }\n   .ant-anchor-link a{text-align: center;     white-space: pre-wrap !important; padding:0px 15px;}\n   .ant-anchor-link:nth-of-type(1){border-left:1px solid #ddd;}\n   .ant-anchor-wrapper:before{border-bottom: 0px !important;}\n   .ant-anchor-link a::before{content:''; display: block; height: 140px;}\n   .text{line-height:30px; display: block;}\n   .ant-anchor-link:nth-of-type(1) a::before, .ant-anchor-link:nth-of-type(4) a::before{background: url(../../static/images/a1.png) no-repeat center 40px; }\n   .ant-anchor-link:nth-of-type(2) a::before, .ant-anchor-link:nth-of-type(5) a::before{background: url(../../static/images/a2.png) no-repeat center 40px; }\n   .ant-anchor-link:nth-of-type(3) a::before, .ant-anchor-link:nth-of-type(6) a::before{background: url(../../static/images/a3.png) no-repeat center 40px; }\n   .ant-affix{\n      .ant-anchor-link{\n         flex:1; border:1px solid #ddd; border-left:0px; height:50px; line-height:40px; background:#fff; \n         text-align: center; cursor: pointer; padding-inline:0px !important;\n      }\n      .ant-anchor-link a::before{content:''; display: none;}\n      .ant-anchor-link:nth-of-type(1){border-left:1px solid #ddd;}\n   }\n}\n.zhijian{width:100%; background:#f2f5fa; padding-bottom: 50px; min-width: 1200px;\n   .content{width:100%; background: url(../../static/images/aiback-a.jpg) no-repeat top center; height:399px;\n      &-right{width:1200px; margin:0px auto; padding-top:60px;}\n      ul{width:74%; margin-left:26%; background:rgba(255,255,255,0.8); border-radius:10px; height:260px; display: flex; flex-wrap: wrap; padding:10px;}\n      li{width:45%; font-size:14px; padding:10px; box-sizing: border-box;\n         h3{margin: 0px; line-height:40px;}\n      }\n      li:nth-of-type(2n+1){width:55%;}\n   }   \n}\n.toubiao{padding-bottom:50px; \n   ul{width:1200px; margin:0px auto; display: flex; justify-content: space-between;}\n   li{width:288px; background:#fff; box-shadow: 0px 0px 5px 5px rgba(0,0,0,0.05);\n      h3{margin:0px; padding:0px 15px; line-height: 50px; font-size:16px;}\n      p{font-size: 14px; padding:0px 15px; line-height: 30px; margin:0px; padding-bottom:20px; color:#555;}\n   }\n}\n.hetong{width:100%; background:#f2f5fa; padding-bottom: 50px; min-width: 1200px;\n   ul{width:1200px; margin:0px auto; display: flex; justify-content: space-between; flex-wrap: wrap;}\n   .list{margin:0px 15px 15px 15px;}\n   li{width:calc(33.3% - 10px); box-sizing: border-box; margin-bottom:15px; background:#fff; box-shadow: 0px 0px 5px 5px rgba(0,0,0,0.05);}\n   p{\n      font-size:14px; line-height:34px; background:#fbfbfe url(../../static/images/hetong-bg.png) no-repeat bottom right; margin:10px;\n      padding:15px 10px; height:120px; color:#555;\n   }\n   &-con{\n      h3{font-size: 16px; padding-left:20px;}\n   }\n   \n   \n}\n.suppleBox{\n   ul{width:1200px; margin:0px auto; display: flex; justify-content: space-between; flex-wrap: wrap;}\n   li{\n      width:calc(50% - 10px); box-shadow: 0px 0px 5px 5px rgba(0,0,0,0.05); box-sizing: border-box; \n      margin-bottom:20px; border-radius:5px; padding-bottom:20px;\n      h3{font-size: 16px; padding-left:20px; margin: 0px; line-height:50px;;}\n   }\n   li:nth-of-type(2n+1){margin-right:20px;}\n   p{\n      font-size:14px; line-height:34px; margin:0px;\n      padding:0px 20px; color:#555;\n   }\n   \n}\n.jiage{width:100%;  padding-bottom: 50px;\n   ul{width:1200px; margin:0px auto; display: flex; justify-content: space-between;}\n   li{\n      flex:1; box-shadow: 0px 0px 5px 5px rgba(0,0,0,0.05); box-sizing: border-box; background:#fff;\n      border-radius:5px; padding-bottom:20px; border-radius:5px; padding:20px;\n   }\n   .list{margin:0px 20px 0px 20px;}\n   p{\n      font-size:14px; line-height:34px; margin:0px; color:#555;\n   }\n}\n.shichang{width:100%; padding-bottom: 50px; background:#f2f5fa; min-width: 1200px;\n   ul{width:1200px; margin:0px auto; display: flex; justify-content: space-between;}\n   li{\n      flex:1; box-sizing: border-box; background:#fff;\n      border-radius:5px; padding-bottom:20px; border-radius:5px;\n   }\n   .titleicon{display: flex;\n      h3{padding-left:20px;}\n   }\n   .list{margin:0px 40px 0px 40px;}\n   p{\n      font-size:14px; line-height:34px; margin:0px; color:#555;\n   }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
